import Spinner from "@pyrogenic/perl/lib/bootstrap/Spinner";

export default Spinner;
